// ----------------------------------------------------------------------
// <copyright file="Izenda.GridLayoutUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
/**
 * Report utilities
 */

!(function() {
  const { get, some, max, map, isNil } = require('lodash/fp');
  /**
   * Check intersects
   * @param  {Object}   tile         Current Object need to check position
   * @param  {Array}    otherTiles   Other Object already on grid
   * @return {Boolean}
   */
  var checkIntersects = function(tile, otherTiles) {
    var aLeft = tile.positionX;
    var aRight = tile.positionX + tile.width - 1;
    var aTop = tile.positionY;
    var aBottom = tile.positionY + tile.height - 1;

    var colliding = function(b) {
      var bLeft = b.positionX;
      var bRight = b.positionX + b.width - 1;
      var bTop = b.positionY;
      var bBottom = b.positionY + b.height - 1;

      return !(bLeft > aRight || bRight < aLeft || bTop > aBottom || bBottom < aTop);
    };

    return some(colliding, otherTiles);
  };

  module.exports = function(numbderOfColumn, defaultWidth, defaultHeight) {
    /**
     * Get default dimension of new tile
     * @param  {Array} tiles     List of existing object
     * @return {Object}
     */
    var getDefaultDimension = function(tiles) {
      var lastPositionY =
        max(
          map(function(item) {
            return item.positionY + (item.height || 3);
          }, tiles)
        ) || 0;

      return {
        positionX: 0,
        positionY: lastPositionY,
        width: defaultWidth,
        height: defaultHeight
      };
    };

    /**
     * Get dimension of new tile
     * @param  {Object} left
     * @param  {String} top
     * @return {String}
     */
    var getDimension = function(otherTiles, left, top) {
      if (isNil(left) || isNil(top)) {
        return getDefaultDimension(otherTiles);
      }
      var dims = {
        positionX: left || 0,
        positionY: top || 0,
        width: 1,
        height: 1
      };

      while (
        !checkIntersects(dims, otherTiles) &&
        dims.width < defaultWidth &&
        dims.width + dims.positionX < numbderOfColumn
      ) {
        dims.width++;
      }
      if (checkIntersects(dims, otherTiles)) {
        dims.width--;
      }
      while (!checkIntersects(dims, otherTiles) && dims.height < defaultHeight) {
        dims.height++;
      }
      if (checkIntersects(dims, otherTiles)) {
        dims.height--;
      }
      return dims;
    };

    /**
     * get avaiable position to add new item
     * @param  {Array} otherTiles   Existing objects
     * @param  {int} width          Defaullt width of new object
     * @param  {int} height         Default height of new object
     */
    var getAvaiablePosition = function(otherTiles, width, height) {
      if (isNil(width) || isNil(height)) {
        return getDefaultDimension(otherTiles);
      }
      var dims = {
        positionX: 0,
        positionY: 0,
        width: width,
        height: height
      };

      // Check with row
      while (true) {
        dims.positionX = 0;
        // With position row n column m check avaiable position
        while (dims.positionX < numbderOfColumn - dims.width) {
          if (!checkIntersects(dims, otherTiles)) {
            break;
          }
          dims.positionX++;
        }
        if (!checkIntersects(dims, otherTiles)) {
          break;
        }
        dims.positionY++;
      }
      return dims;
    };

    return {
      getDefaultDimension: getDefaultDimension,
      checkIntersects: checkIntersects,
      getDimension: getDimension,
      getAvaiablePosition: getAvaiablePosition
    };
  };
})();



// WEBPACK FOOTER //
// ./ui/share/utils/Izenda.GridLayoutUtils.js